import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';
import { redDark } from 'styles/colors';

export const HelperText = styled.span`
	display: inline-flex;
	align-items: center;
	padding-left: 16px;
	font-size: 13px;
	line-height: 19px;
	letter-spacing: 0.3px;
	color: ${colors.grey5};

	${({ isWarning }) => isWarning && `color: ${redDark}`};
`;

export const IconWrapper = styled.div`
	display: inline-flex;
	margin-left: 8px;
`;
